import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IdiomaModel } from '../sso/models/idioma.model';

export class TextoModel {
  public Id: string;
  public Texto: string;
}

@Injectable({
  providedIn: 'root',
})
export class LangService {
  public textos = new Map<string, string>();

  constructor(private http: HttpClient) {}

  translate(textId: string): string {
    let res = '';
    res = this.textos.get(textId.toLowerCase());
    if (res === undefined || res === null) {
      res = '';
    }
    return res;
  }

  public async getText(
    idiomaId: number,
    throwOnError = false,
  ): Promise<boolean> {
    let response: TextoModel[] | null = null;

    try {
      const apiSSO = environment.apiSSO;
      response = await this.http
        .get<TextoModel[]>(apiSSO + '/sso/textos/' + idiomaId)
        .toPromise();
    } catch (e) {
      console.debug(e);
      if (throwOnError) {
        throw e;
      }
      return false;
    }

    // Si la API respondió correctamente, no bloqueamos navegación aunque algún item venga mal formado.
    this.textos.clear();
    (response ?? []).forEach((texto) => {
      const textId = texto?.Id;
      if (!textId) {
        return;
      }

      this.textos.set(textId.toLowerCase(), texto.Texto ?? '');
    });

    // Marcamos idioma cargado tras respuesta HTTP exitosa para evitar redirecciones falsas.
    // this.loadedLanguageId = idiomaId;

    if (response === null && throwOnError) {
      throw new Error('Language API returned no data');
    }

    return true;
  }

  async getIdiomas(): Promise<IdiomaModel[]> {
    const result: IdiomaModel[] = [];
    try {
      const response = await this.http
        .get(environment.apiSSO + '/sso/idiomas')
        .toPromise();
      if (response !== null) {
        return <IdiomaModel[]>JSON.parse(JSON.stringify(response));
      }
    } catch {}
    return null;
  }
}
